import { useCallback } from "react";
import { UnusualTextPhrases } from "../models/responses/suggestion";
import { trigramsApi } from "../services/trigrams.ts";
import { useAppDispatch } from "../store";

export const useWorkerMessageHandlers = () => {
  const dispatch = useAppDispatch();

  const handleUnusualPhrases = useCallback(
    ({ appId, unusualPhrases }: { appId: string; unusualPhrases: Array<UnusualTextPhrases> }) => {
      dispatch(
        trigramsApi.endpoints.updateTrigramsForApp.initiate(
          {
            appId,
            unusualPhrases,
          },
          { track: false }
        )
      );
    },
    [dispatch]
  );

  return { handleUnusualPhrases };
};
